/* eslint-disable class-methods-use-this */
import Resource from '@/services/resources/common';

export default class DashboardLayoutResource extends Resource {
  constructor(entrypoint = '/dashboard_layouts', alias = 'DashboardLayout') {
    super(entrypoint, alias);
  }
}
